// frontend/src/components/ESIMPackages/ESIMPackageTable.js
import React from "react";
import GenericTable from "../GenericTable";
import ESIMPackageRow from "./ESIMPackageRow";
import { useTranslation } from "react-i18next";

const ESIMPackageTable = ({
  packages,
  orderBy,
  order,
  onSort,
  onPurchase,
  loading,
  pagination,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      id: "name",
      label: t("esim.packages.columns.name"),
      sortable: true,
    },
    {
      id: "price",
      label: t("esim.packages.columns.price"),
      align: "right",
      sortable: true,
    },
    {
      id: "data",
      label: t("esim.packages.columns.data"),
      align: "right",
      sortable: true,
    },
    {
      id: "duration",
      label: t("esim.packages.columns.duration"),
      align: "right",
      sortable: true,
    },
    {
      id: "perGB",
      label: t("esim.packages.columns.perGB"),
      align: "right",
    },
    {
      id: "speed",
      label: t("esim.packages.columns.speed"),
      align: "center",
    },
    {
      id: "actions",
      label: t("esim.packages.columns.actions"),
      align: "center",
    },
  ];

  return (
    <GenericTable
      columns={columns}
      data={packages}
      orderBy={orderBy}
      order={order}
      onSort={onSort}
      loading={loading}
      emptyMessage={t("esim.packages.noPackages")}
      pagination={pagination}
      renderRow={(pkg) => (
        <ESIMPackageRow
          key={pkg.packageCode}
          pkg={pkg}
          onPurchase={onPurchase}
        />
      )}
      sx={{
        "& .MuiTableCell-head": {
          whiteSpace: "nowrap",
          paddingLeft: 2,
          paddingRight: 2,
        },
        "& .MuiTableCell-body": {
          whiteSpace: "nowrap",
          paddingLeft: 2,
          paddingRight: 2,
        },
      }}
    />
  );
};

export default ESIMPackageTable;
